import service from '@/utils/request'
// 查询用户关联询价单
export function inquiryUserList(param) {
    return service.request({
        method: 'POST',
        url: '/app/inquiryUser/inquiryUserList',
        data: param
    })
}
// 查询用户关联询价单 不分页
export function inquiryUserListAll() {
    return service.request({
        method: 'POST',
        url: '/app/inquiryUser/list',
    })
}
// 新增用户关联询价单
export function addInquiryUser(param) {
    return service.request({
        method: 'POST',
        url: '/app/inquiryUser/add',
        data: param
    })
}
// 修改用户关联询价单
export function editInquiryUser(param) {
    return service.request({
        method: 'POST',
        url: '/app/inquiryUser/edit',
        data: param
    })
}

// 批量删除用户关联询价单
export function batchDelInquiryUser(param) {
    return service.request({
        method: 'POST',
        url: '/app/inquiryUser/batchDel',
        data: param
    })
}



// 删除用户关联询价单
export function delInquiryUser(param) {
    return service.request({
        method: 'POST',
        url: '/app/inquiryUser/del',
        data: param
    })
}

// 参与
export function joinInquiry(param) {
    return service.request({
        method: 'POST',
        url: '/app/inquiryUser/joinInquiry',
        data: param
    })
}

// 放弃
export function giveUpInquiry(param) {
    return service.request({
        method: 'POST',
        url: '/app/inquiryUser/giveUpInquiry',
        data: param
    })
}
